import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';
import { applyPolyfills, defineCustomElements } from '@examsoft/haste-ui/dist/loader';
applyPolyfills().then(() => {
  defineCustomElements(window)
});


window['newrelic'].addPageAction('app-start', { referrer: document.referrer, userAgent: navigator.userAgent });


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));
